import {IMainDb} from "../db/mainDb";
import {TeamInfo, UserInfo} from "../../models/utilTypes";
import {UserRole} from "../../models/fixture/userRole";
import {OpenLevel} from "../../models/fixture/openLevel";
import {createId} from "../../models/util";
import {Firebase} from "../db/firebase";

export interface IUserRepository {
  info(id:string): Promise<UserInfo>;
  updateInfo(id:string, name: string, email: string): Promise<void>;
  delete(id:string):Promise<void>;
  joinTeam(userId:string, teamName:string, teamRegion:number, teamPassword:string): Promise<TeamInfo>;
  exitTeam(userId:string): Promise<void>;
  createTeam(userId:string, teamName:string, teamPassword:string, regionNum:number, openLevel:OpenLevel): Promise<TeamInfo>
  updateTeam(teamId:string, teamName:string, teamPassword:string, teamRegion:number, openLevel: OpenLevel): Promise<void>
  deleteTeam(userId:string, teamId:string): Promise<void>
}

export class UserRepository implements IUserRepository {

  private static _instance: UserRepository;
  private readonly mainDb: IMainDb;

  constructor() {
    this.mainDb = Firebase.instance as IMainDb;
  }

  static get instance() {
    if(!this._instance) {
      this._instance = new UserRepository()
    }
    return this._instance;
  }

  async info(id:string) {
    return await this.mainDb.getUser(id);
  }

  async updateInfo(id:string, name:string, email:string) {
    await this.mainDb.updateUser(id, name, email);
  }

  async delete(id:string) {
    await this.mainDb.deleteUser(id);
  }

  async joinTeam(userid:string,teamName:string, teamRegion:number, teamPassword:string) {
    const matchedTeam: TeamInfo | undefined =  await this.mainDb.checkMatchedTeam(teamName, teamRegion);
    if (matchedTeam) {
      if(matchedTeam.password === teamPassword) {
        await this.mainDb.updateUserMyTeam(userid, matchedTeam.id, UserRole.member);
        return matchedTeam;
      } else {
        throw new Error('パスワードが間違っています');
      }
    } else {
      throw new Error('該当するチームが見つかりません');
    }
  }

  async exitTeam(userId:string) {
    // チームDBに所属者を記録してないのでユーザー情報の更新のみでOK
    await this.mainDb.updateUserMyTeam(userId,'', UserRole.general);
  }

  async createTeam(userId:string, teamName:string, teamPassword:string, regionNum:number, openLevel:OpenLevel) {
    const matchedTeam: TeamInfo | undefined =  await this.mainDb.checkMatchedTeam(teamName, regionNum);
    if (!matchedTeam) {
      const id = 't_' + createId();
      await this.mainDb.createTeam(teamName, teamPassword, regionNum, openLevel, id);
      await this.mainDb.updateUserMyTeam(userId, id, UserRole.member);
      const teamInfo: TeamInfo = {
        id: id, region: regionNum, openLevel: openLevel, password: "", name: teamName
      }
      return teamInfo;
    } else {
      throw new Error('同じ地域に同じチーム名が存在します');
    }
  }

  async updateTeam(teamId:string, teamName:string, teamPassword:string, teamRegion:number, openLevel: OpenLevel) {
    await this.mainDb.updateTeam(teamId, teamName, teamPassword, teamRegion, openLevel);
  }

  async deleteTeam(userId:string, teamId:string) {
    await this.mainDb.deleteTeam(teamId);
    await this.mainDb.updateUserMyTeam(userId, '', UserRole.general);
  }
}
